// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2694":"334a4c65","4893":"8adf07e6","5414":"37e3c5cc"}[chunkId] + ".css";
};